import globeVector from '../../../../../_metronic/assets/images/svg/data-room/globe-vector.svg'
import mailVector from '../../../../../_metronic/assets/images/svg/data-room/mail-vector.svg'
import {DisplayImage} from '../../../widgets/components/General/DisplayImage'
export function RoomPreviewDropdown({
  isOpen,
  userFirstName,
  userLastName,
  userEmail,
  companyUrl,
  userIcon,
}: {
  isOpen: boolean
  userFirstName: string
  userLastName: string
  userEmail: string
  companyUrl: string
  userIcon: string
}) {
  return isOpen ? (
    <div className='menu menu-sub menu-sub-dropdown room-preview-dropdown show'>
      <div className='d-flex flex-row align-items-center user-wrapper'>
        <DisplayImage imgName={userIcon} width='100%' alt='profile' fit='contain' height='50px' />
        <h6 className='mb-0'>
          {userFirstName} {userLastName}
        </h6>
      </div>
      <a href={companyUrl} className='d-flex flex-row align-items-center user-links dark_text_color'>
        <img src={globeVector} alt=''></img>
        <span className='dark_text_color'>{companyUrl || '-'}</span>
      </a>
      <p className='d-flex flex-row align-items-center user-links'>
        <img src={mailVector} alt=''></img>
        <span className='ms-2'>{userEmail || '-'}</span>
      </p>
    </div>
  ) : null
}
